import Vue from 'vue';
import ElementUI from 'element-ui';
import VueRouter from 'vue-router';
import LocalForage from 'localforage';
import './axios.config';
import './javaAxios.config';
import './api.config';
import './math.config';
import untils from './assets/scripts/untils';
import store from './store.config';
import routerConfig from './router.config';
import pluginEng from './engineering/plugin.eng';
import './assets/styles/reset.less';
import VueClipboard from 'vue-clipboard2';
// import vueEsign from 'vue-esign';

// 这里的代码只需要满足路由、组件和指令三个功能，其他功能在客户端入口中实现
module.exports = (vueConf = {}) => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      Vue.use(ElementUI); // 开发环境才install依赖，生产环境直接使用cdn

    }

    Vue.use(VueRouter);
    Vue.use(VueClipboard);
    // 处理路由双击问题
    const originalPush = VueRouter.prototype.push;
    VueRouter.prototype.push = function push(location) {
      return originalPush.call(this, location).catch(err => err)
    }

    // 插件配置
    const pluginPromises = [];
    pluginEng.map(o => o.replace(/^src/i, '.')).forEach(key => {
      // eslint-disable-next-line prefer-template
      pluginPromises.push(import('' + key)); // 需要在前面加字符，否者不生效
    })
    Promise.all(pluginPromises).then(components => {
      components.forEach(({
        default: component
      }) => {
        if (component.name) {
          Vue.component(component.name, component);
        }
      });
    });

    // 单元方法
    Object.keys(untils).forEach(key => {
      Vue.prototype[`$${key}`] = untils[key];
    });
    Vue.prototype.$LocalForage = LocalForage;

    // 路由配置
    routerConfig.then(({
      routes
    }) => {
      const router = new VueRouter({
        mode: 'hash',
        scrollBehavior: () => ({
          y: 0
        }),
        routes,
      });

      // 路由跳转前触发
      router.beforeEach((to, from, next) => {
        // vue hash SPA页面特殊处理
        if (to.path && router.mode === 'hash' && from) {
          Vue.prototype.$baidutongji.trackpageview([`/#${to.fullPath}`]); // 发送页面 PV
        }
        next(vm => {console.log('vm',vm)});
      });

      // 系统文件
      const fileConfigs = [];
      routes.forEach(item => {
        if ((item.children || []).length > 0) {
          item.children.forEach(child => {
            fileConfigs.push({
              path: `${item.path}/${child.path}`,
              title: child.title,
              icon: child.icon || 'el-icon-help',
              parent: item.path,
              sort: child.sort,
              group: child.group
            });
          });
        }
      });

      const created = vueConf.created ? vueConf.created : () => { };
      const app = new Vue({
        store,
        router,
        template: '<router-view />',
        created,
      });

      resolve({
        router,
        store,
        app,
        fileConfigs
      });
    }).catch(reject);
  });
}
